angular.module('impactx.sapconfig').controller('SAPMaterialNumberListCtrl', [
    'selectedListItems',
    '$mdDialog',
    'ListHelperService',
    '$scope',
    'ToastService',
    'TranslationService',
    'dataGen',
    SAPMaterialNumberListCtrl]);

function SAPMaterialNumberListCtrl(selectedListItems, $mdDialog, ListHelperService, $scope, ToastService, TranslationService, dataGen) {

    var ctrl = this;
    this.delete = function () {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        dataGen.postAsForm({}, {ids: selectedListItems.getSelectedIds()}, "/sapconfiguration/deletematnr").then(function (data) {
            ListHelperService.refreshListData($scope, 'sapMaterialNumberListCtrl', {unselectRows: selectedItems});
            ToastService.openStandardToast(TranslationService.get("deleteSuccess"));
        })
    };

    this.createMaterialNumber = function (event) {
        ctrl.showMaterialNumberDialog(event, 0);
    };

    this.editMaterialNumber = function (event) {
        ctrl.showMaterialNumberDialog(event, selectedListItems.getFirstSelectedId());
    };

    this.showMaterialNumberDialog = function (event, id) {
        var selectedItems = JSON.parse(JSON.stringify(selectedListItems.getSelectedItems()));
        $mdDialog.show({
            controller: "MaterialNumberCreationCtrl",
            controllerAs: "materialNumberCreationCtrl",
            templateUrl: "modules/sapconfig/templates/materialnumbercreation.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            multiple: true,
            locals: {
                id: id
            }
        }).then(function () {
            ListHelperService.refreshListData($scope, 'sapMaterialNumberListCtrl', {unselectRows: selectedItems});
        }, function () {
            ListHelperService.refreshListData($scope, 'sapMaterialNumberListCtrl', {unselectRows: selectedItems});
        });
    };

    this.importSapMatNr = function (event, trns) {
        $mdDialog.show({
            controller: "SapMatNrImportCtrl",
            controllerAs: "ctrl",
            templateUrl: "modules/sapconfig/templates/sapmatnr-importview.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            bindToController: true,
            locals: {
                trns: trns,
            }
        }).then(function () {
            ListHelperService.refreshListData($scope, 'sapMaterialNumberListCtrl', {unselectRows: []});
        }, function () {
            ListHelperService.refreshListData($scope, 'sapMaterialNumberListCtrl', {unselectRows: []});
        })
    };

    var buttonDefinition = [
        {label: "details", action: ctrl.editMaterialNumber, condition: selectedListItems.isSingleSelection, process: 'SAPConfiguration'},
        {label: "delete", action: ctrl.delete, condition: selectedListItems.isMultiSelection, process: 'SAPConfiguration'},
        {label: "import", action: ctrl.importSapMatNr, condition: selectedListItems.isNoSelection, process: 'SAPConfiguration'}
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/sapconfig/templates/sapmatnr.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/sapconfiguration/listmatnr',
        ctrl: this,
        id: "sapmatnr",
        mainActionFunction: {id: "new", action: this.createMaterialNumber, icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };
}